import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TUserClient, adaptUserClientFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_USER_CLIENT}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_USER_CLIENT}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptUserClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientDeleteSlice = createSlice({
	name: 'userClientDeleteSlice',
	initialState,
	reducers: {
		clearUserClientDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientDeleteApi.fulfilled.type]: (state, action: PayloadAction<TUserClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientDeleteSelector = () => useAppSelector(state => state[userClientDeleteSlice.name]);

export const { clearUserClientDelete } = userClientDeleteSlice.actions;
